module.exports = __webpack_public_path__ + "139fa24f448ebc749196c856437bcefc.pdf";